goog.provide('el8.app.onboarding.TestAccountDialog');

goog.require('el8.uiwidget.NewDialog');
goog.require('el8.model.base');

el8.app.onboarding.TestAccountDialog = function() {
    el8.uiwidget.NewDialog.apply(this, arguments);
};
el8.app.onboarding.TestAccountDialog.inheritsFrom(el8.uiwidget.NewDialog);

el8.app.onboarding.TestAccountDialog.prototype._init = function() {

    el8.uiwidget.NewDialog.prototype._init.apply(this, arguments);

    // This is the parent class that we can do all the custom 
    // CSS styling off of for the "test account" dialogs
    this.getDialogContainer().addClass('testAccountDialog');
};

